'use client';

import {
  type CSSVariablesResolver,
  type MantineProviderProps,
  mergeThemeOverrides,
} from '@mantine/core';
import { themeToVars } from '@mantine/vanilla-extract';
import { palette } from 'ui-lib/src/lib/color/palette';

import { borders } from './borders';
import { colors } from './colors';
import { components } from './components';
import { shadows } from './shadows';
import { spacing } from './spacing';
import { typography } from './typography';

export const theme = mergeThemeOverrides(borders, colors, shadows, spacing, typography, components);

export const mantineVars = themeToVars(theme);

/**
 * Custom CSS variables resolver to override Mantine's default error color
 * to match ui-lib's error color (palette.red[100] = #E01E29)
 */
export const cssVariablesResolver: CSSVariablesResolver = () => ({
  variables: {},
  light: {
    '--mantine-color-error': palette.red[100],
  },
  dark: {
    '--mantine-color-error': palette.red[100],
  },
});

export const mantineProviderProps = {
  theme,
  cssVariablesResolver,
  forceColorScheme: 'light',
} satisfies MantineProviderProps;
